import React, { FC } from "react";
import { Center, Heading } from "@chakra-ui/react";

const PageNotFound: FC = () => {
  return (
    <Center height="100%" width="100%">
      <Heading>404 - Not Found</Heading>
    </Center>
  );
};

export default PageNotFound;
